import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

import { onAuthDispatch as dispatchSelector } from 'reduxModules/auth/dispatchers'
import LoginBox from '../../generic/LoginBox'
import '../styles.css'
import './styles.css'

export class SignIn extends Component {
  constructor(props) {
    super(props)
    props.hideGlobalNav()
  }

  componentWillUnmount() {
    this.props.showGlobalNav()
  }

  render() {
    return (
      <div id="SignIn" className="auth-page">
        <div>
          <header className="logo">
            <Link to="/">
              <img src="/global/assets/images/logo/logo-big.png" alt="Stan Winston School Of Character Arts" />
            </Link>
          </header>
          <LoginBox autoFocus {...this.props} isMain />
        </div>
      </div>
    )
  }
}

SignIn.propTypes = {
  hideGlobalNav: PropTypes.func.isRequired,
  showGlobalNav: PropTypes.func.isRequired
}

const ConnectedSignIn = connect(null, dispatchSelector)(SignIn)

// dispatchLogin reads location.state.next to redirect after a successful
// login (set by RequireAuth); class components can't call useLocation, so
// inject it here.
export default function SignInPage(props) {
  const location = useLocation()
  return <ConnectedSignIn {...props} location={location} />
}
